<template>
  <div>
    <div class="form-group">
      <div class="row">
        <div class="col-3 col-sm-4">
          <div class="row">
            <div class="col-6">
              <label class="label"
                     :for="`num_cnj_${ _uid }`">CNS</label>
              <input :id="`num_cnj_${ _uid }`"
                     v-model="busca.num_cnj"
                     type="text"
                     min="0"
                     max="999999"
                     maxlength="6"
                     class="form-control form-control-sm"
                     placeholder="000000"
                     @change="pesquisarCartorios()">
            </div>

            <div class="col">
              <label class="label"
                     :for="`uf_${ _uid }`">UF</label>
              <v-select :id="`uf_${ _uid }`"
                        v-model="busca.uf"
                        class="form-control form-control-sm"
                        :options="estados.map((state)=> state.uf)"
                        @input="ufChanged" />
            </div>
          </div>
        </div>

        <div class="col-3">
          <label class="label"
                 :for="`cidade_${ _uid }`">Cidade</label>
          <v-select :id="`cidade_${ _uid }`"
                    v-model="busca.cidade"
                    :disabled="cidades.length == 0"
                    class="form-control form-control-sm"
                    :options="cidades.map(cidade => cidade.nome)"
                    @input="onSelectCidade" />
        </div>

        <div class="col">
          <label class="label"
                 :for="`cartorio_${ _uid }`">Cartório</label>
          <v-select :id="`cartorio_${ _uid }`"
                    v-model="busca.nome_cartorio"
                    label="nome"
                    class="form-control form-control-sm"
                    :disabled="cartorios.length == 0"
                    :options="cartorios.map(cartorio => cartorio.NOME)"
                    @input="selectedCartorio" />
          <small v-if="cartorios.length == 0 && show.cartorioMsg"
                 class="text-danger">
            Nenhum cartorio encontrado com esse UF e Cidade
          </small>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-2 col-sm-3">
          <label :for="`cartorio_${ _uid }`"
                 class="label">
            CPF do Registrado
          </label>
          <input :id="`cpf_registrado_${ _uid }`"
                 v-model="busca.cpf_registrado"
                 v-mask="`999.999.999-99`"
                 type="text"
                 placeholder="000.000.000-00"
                 class="form-control form-control-sm">
        </div>
        <div class="col">
          <label :for="`nome_registrado_completo_${ _uid }`"
                 class="label">
            Nome do Registrado
          </label>
          <input v-if="busca.tipo_registro != 'C'"
                 :id="`nome_registrado_completo_${ _uid }`"
                 v-model="busca.nome_registrado_completo"
                 v-uppercase
                 type="text"
                 class="form-control form-control-sm">
          <input v-if="busca.tipo_registro == 'C'"
                 :id="`nome_registrado_completo_${ _uid }`"
                 v-model="busca.nome_reg_1_completo"
                 v-uppercase
                 type="text"
                 class="form-control form-control-sm">
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <label :for="`matricula_${ _uid }`"
                 class="label">
            Matrícula
          </label>
          <input v-model="busca.matricula"
                 v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
                 type="text"
                 class="form-control form-control-sm matricula-registro-anterior">
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <box-tipo v-model="busca.tipo_registro"
                    :prop-tipo-registro="busca.tipo_registro" />
        </div>

        <div class="col-4 d-flex align-items-end justify-content-end">
          <div class="row">
            <div class="col mb-1">
              <label :for="`num_livro_${ _uid }`"
                     class="label">
                Livro
              </label>
              <input :id="`num_livro_${ _uid }`"
                     v-model="busca.num_livro"
                     v-zero-before
                     maxlength="5"
                     type="number"
                     class="form-control form-control-sm">
            </div>
            <div class="col">
              <label :for="`num_folha_${ _uid }`"
                     class="label">
                Folha
              </label>
              <input :id="`num_folha_${ _uid }`"
                     v-model="busca.num_folha"
                     v-zero-before
                     maxlength="3"
                     type="number"
                     class="form-control form-control-sm">
            </div>
            <div class="col-5">
              <label :for="`num_registro_${ _uid }`"
                     class="label">
                Termo
              </label>
              <input :id="`num_registro_${ _uid }`"
                     v-model="busca.num_registro"
                     v-zero-before
                     maxlength="7"
                     type="number"
                     class="form-control form-control-sm">
            </div>
          </div>
        </div>
      </div>

      <div v-if="busca.tipo_registro == 'C'"
           class="row">
        <div class="col">
          <div class="RegistrosAnterioresBusca--tipoBox p-2 pl-3 pr-3">
            <div class="row">
              <div class="col">
                <div class="form-group form-inline m-0">
                  <label class="label mr-2"
                         for="religiosoSim">
                    Religioso
                  </label>

                  <span class="custom-control custom-radio mr-2">
                    <input id="religiosoSim"
                           v-model="busca.religioso"
                           class="custom-control-input"
                           name="religiosoPesq"
                           :value="true"
                           type="radio">
                    <label class="custom-control-label"
                           for="religiosoSim">Sim</label>
                  </span>

                  <span class="custom-control custom-radio">
                    <input id="religiosoNao"
                           v-model="busca.religioso"
                           class="custom-control-input"
                           name="religiosoPesq"
                           :value="false"
                           type="radio">
                    <label class="custom-control-label"
                           for="religiosoNao">Não</label>
                  </span>
                </div>
              </div>
            </div>

            <div class="row mt-2 mb-2">
              <div class="col">
                <label :for="`casamento_nome_reg_2_completo_${ _uid }`"
                       class="label">
                  Nome do Cônjuge
                </label>
                <input :id="`casamento_nome_reg_2_completo_${ _uid }`"
                       v-model="busca.nome_reg_2_completo"
                       type="text"
                       class="form-control form-control-sm">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="busca.tipo_registro == 'N'"
           class="row">
        <div class="col">
          <div class="RegistrosAnterioresBusca--tipoBox p-2 pl-3 pr-3">
            <div class="row mt-2 mb-2">
              <div class="col">
                <label :for="`nascimento_nome_genitor1_completo_${ _uid }`"
                       class="label">
                  Nome do Genitor 1
                </label>
                <input :id="`nascimento_nome_genitor1_completo_${ _uid }`"
                       v-model="busca.nome_genitor1_completo"
                       type="text"
                       class="form-control form-control-sm">
              </div>
              <div class="col">
                <label :for="`nascimento_nome_genitor2_completo_${ _uid }`"
                       class="label">
                  Nome do Genitor 2
                </label>
                <input :id="`nascimento_nome_genitor2_completo_${ _uid }`"
                       v-model="busca.nome_genitor2_completo"
                       type="text"
                       class="form-control form-control-sm">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2 no-gutters">
        <div class="col-4 col-sm">
          <label :for="`data_registro_inicio_${ _uid }`"
                 class="label">
            Data do Registro
          </label>
          <div class="row no-gutters">
            <div class="col-5">
              <input :id="`data_registro_inicio_${ _uid }`"
                     v-model="busca.data_registro_inicio"
                     type="date"
                     class="form-control form-control-sm">
            </div>
            <div class="col-1 d-flex align-items-end justify-content-center">
              <b>até</b>
            </div>
            <div class="col-5">
              <input :id="`data_registro_final_${ _uid }`"
                     v-model="busca.data_registro_fim"
                     type="date"
                     class="form-control form-control-sm">
            </div>
          </div>
        </div>

        <div class="col-4 col-sm">
          <label :for="`data_ocorrido_inicio_${ _uid }`"
                 class="label">
            Data do Ato
          </label>
          <div class="row no-gutters">
            <div class="col-5">
              <input :id="`data_ocorrido_inicio_${ _uid }`"
                     v-model="busca.data_ocorrido_inicio"
                     type="date"
                     class="form-control form-control-sm">
            </div>
            <div class="col-1 d-flex align-items-end justify-content-center">
              <b>até</b>
            </div>
            <div class="col-5">
              <input :id="`data_ocorrido_final_${ _uid }`"
                     v-model="busca.data_ocorrido_fim"
                     type="date"
                     class="form-control form-control-sm">
            </div>
          </div>
        </div>

        <div class="col-2 d-flex align-items-end justify-content-left">
          <b-button variant="outline-primary"
                    class="btn btn-sm"
                    @click="search">
            Pesquisar
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import BoxTipo from "@/components/SofiaRei/BoxTipo"

  /* constants */
  import brazilianStates from "@/constants/brazilianStates"
  import Cidades from "@/constants/repositorio/cidades"

  /* services */
  import CartorioService from "@/services/CartorioService"
  import EnderecosService from "@/services/Enderecos"
  import RegistrosAnterioresService from "@/services/Registros/RegistrosAnterioresService"

  export default {
    name: "RegistrosAnterioresBusca",
    components: {
      BoxTipo
    },
    props: {
      propData: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        show: {
          cartorioMsg: false
        },
        busca: {
          cartorio_id: null,
          num_cnj: null,
          uf: null,
          cidade: null,
          nome_cartorio: null,
          cpf_registrado: null,
          nome_registrado_completo: null,
          matricula: null,
          tipo_registro: 'N',
          num_livro: null,
          num_folha: null,
          num_registro: null,
          nome_genitor1_completo: null,
          nome_genitor2_completo: null,
          data_registro: null,
          data_registro_inicio: null,
          data_registro_fim: null,
          data_ocorrido: null,
          data_ocorrido_inicio: null,
          data_ocorrido_fim: null,
          /* só para casamento*/
          nome_reg_1_completo: null,
          nome_reg_2_completo: null,
          religioso: false
        },
        ordenacao: null,
        estados: [...brazilianStates],
        cidades: [],
        cartorios: [],
        tiposRegistros: {
          N: 'nascimento',
          O: 'obito',
          C: 'casamento'
        }
      }
    },
    watch: {
      'busca.tipo_registro' () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    mounted () {
      this.controlEvent().addEvent()
    },
    methods: {
      async init () {
        switch (this.busca.tipo_registro) {
        case 'N': case 'O':
          Object.assign(this.busca, {
            nome_registrado_completo: this.propData && this.propData.nome_antigo || this.propData.nome || null,

            /**
             * Deixamos cpf nulo pois as informações retornadas do elastic não estão completas.
             * Como o usuário vai direto no botão de pesquisar, pelo menos retorna o que encontrou no batimento.
             */
            cpf_registrado: null
          })
          break

        case 'C':
          Object.assign(this.busca, {
            nome_reg_1_completo: this.propData && this.propData.nome_antigo || this.propData.nome || null
          })
          break
        }

        // Caso o registrado tenha UF e Cidade em seu endereço, pegamos e deixamos já pré selecionado
        if (this.propData.endereco && this.propData.endereco.uf && this.propData.endereco.cidade) {
          this.busca.uf = this.propData.endereco.uf
          await this.ufChanged()

          this.busca.cidade = this.propData.endereco.cidade
          await this.onSelectCidade()
        }
      },
      async search () {
        try {
          loader({ active: true, text: 'Buscando registros anteriores...' })
          const search = { ...this.busca }
          search.tipo_registro = this.tiposRegistros[this.busca.tipo_registro]
          search.cpf_registrado = search.cpf_registrado && search.cpf_registrado.replace(/[.,-]/g, '')
          search.num_livro = search.num_livro != 0 ? search.num_livro : null
          search.num_folha = search.num_folha != 0 ? search.num_folha : null
          search.num_registro = search.num_registro != 0 ? search.num_registro : null
          let registros = await RegistrosAnterioresService.busca(search)
          registros = registros.hits.map(registro => registro._source)
          this.$emit('onGetRegistros', registros, this.busca)
        } finally {
          loader({ active: false })
        }
      },
      async ufChanged () {
        try {
          loader({ active: true, text: 'Carregando cidades por estado' })
          // pegando estado
          const state = this.estados.find(estado => estado.uf == this.busca.uf)
          const cities = Cidades.filter(cidade => cidade.uf == state.uf)
          this.cidades = cities
          this.busca.cidade = null
        } finally {
          loader({ active: false })
        }
      },
      selectedCartorio () {
        const cartorioSelecionado = this.cartorios.find(cartorio => cartorio.NOME == this.busca.nome_cartorio)
        if (cartorioSelecionado && cartorioSelecionado.NUM_CNJ) {
          this.busca.num_cnj = cartorioSelecionado.NUM_CNJ
          this.busca.cartorio_id = cartorioSelecionado.CARTORIO_ID
          this.busca.cidade = cartorioSelecionado.CIDADE
          this.busca.uf = cartorioSelecionado.ESTADO
        }
      },
      async pesquisarCartorios (cidade = null) {
        try {
          loader({ active: true, text: `Pesquisando Cartórios...` })
          const query = {}

          if (this.busca.num_cnj) {
            query.acao = 'cns'
            query.cns = this.busca.num_cnj
          } else if (this.busca.uf && this.busca.cidade) {
            query.acao = 'endereco'
            query.uf = this.busca.uf
            query.cidade = cidade.nome || this.busca.cidade
          }

          this.busca.nome_cartorio = null

          const { data: { result } } = await CartorioService.pesquisarCartorios(query)

          if (query.acao == 'cns') {
            this.cartorios = [result.cartorios[0]]

            if (this.cartorios[0].NOME) this.busca.nome_cartorio = this.cartorios[0].NOME
            if (this.cartorios[0].ESTADO) this.busca.uf = this.cartorios[0].ESTADO
            await this.ufChanged()
            if (this.cartorios[0].CIDADE) this.busca.cidade = this.cartorios[0].CIDADE
            if (this.cartorios[0].CARTORIO_ID) this.busca.cartorio_id = this.cartorios[0].CARTORIO_ID
          } else {
            if (result.cartorios) this.cartorios = result.cartorios

            /*if (this.cartorios.length == 1) {
              if (this.cartorios[0].NOME) this.busca.nome_cartorio = this.cartorios[0].NOME
              if (this.cartorios[0].ESTADO) this.busca.uf = this.cartorios[0].ESTADO
              if (this.cartorios[0].CIDADE) this.busca.cidade = this.cartorios[0].CIDADE
            }*/
          }

          if (this.cartorios.length == 0) {
            this.show.cartorioMsg = true
          } else {
            this.show.cartorioMsg = false
          }

        } finally {
          loader({ active: false })
        }
      },
      async onSelectCidade () {
        const cidade = this.cidades.find(cidade => cidade.nome == this.busca.cidade)
        if (cidade) {
          this.busca.num_cnj = null
          this.pesquisarCartorios(cidade)
        }
      },
      controlEvent () {
        const addEvent = () => {
          setTimeout(() => {
            const abas = document.querySelectorAll('.tipos-registros-anteriores')
            const matricula = document.querySelector('.matricula-registro-anterior')

            if (abas.length) {
              abas.forEach(aba => {
                aba.onkeydown = nextAba
              })
            }

            if (matricula) {
              matricula.onkeydown =  firstAba
            }
          }, 400)
        }

        const nextAba = (event) => {
          if (event.key != 'Tab') return

          const abas = document.querySelectorAll('.tipos-registros-anteriores')

          const abasArr = Array.from(abas)

          const index = abasArr.findIndex(aba => aba.id == event.target.id)

          if (index != -1 && index != abasArr.length - 1) {
            setTimeout(() => {
              abas[index + 1].focus()
            }, 100)
          }
        }

        const firstAba = (event) => {
          if (event.key != 'Tab') return

          const abas = document.querySelectorAll('.tipos-registros-anteriores')

          if (abas && abas.length) {
            setTimeout(() => {
              abas[0].focus()
            }, 300)
          }
        }

        return { addEvent, nextAba, firstAba }
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../scss/_utilities/_exports";

  .RegistrosAnterioresBusca {
    &--tipoBox {
      border: 4px solid $sofiaRei-blue;
    }
  }
</style>
